export default {
  error: {
    pieceSmartInvalidLines: '第 {lines} 行格式不正确；每行必须包含长、宽、高、件数四个数字',
    networkError: '网络连接失败',
    requestFailed: '请求失败',
    paramError: '请求参数错误',
    loginExpired: '登录已过期，请重新登录',
    noPermission: '没有权限执行此操作',
    noPageAccess: '您没有任何页面访问权限，请联系管理员',
    notFound: '请求的资源不存在',
    concurrencyConflict: '数据已被他人修改，请刷新页面后重试',
    serverError: '服务器内部错误',
    unknown: '未知错误',
    timeout: '请求超时，请重试',
    loadCustomerListFailed: '加载客户列表失败',
    loadDictFailed: '加载字典数据失败',
    loadUserListFailed: '获取用户列表失败',
    loadRoleListFailed: '获取角色列表失败',
    loadOrgTreeFailed: '获取组织机构树失败',
    configUpdateFailed: '配置更新失败',
    resetPasswordFailed: '重置密码失败',
    deleteFailed: '删除失败',
    loadDictListFailed: '获取字典列表失败',
    queryFailed: '查询失败',
    saveFailed: '保存失败',
    updateStatusFailed: '操作失败',
    batchGenerateFailed: '批量生成失败',
    batchPreviewInvalid: '批量生成预览为空或分配总量不一致，请检查子协议和日期选择',
    getDetailFailed: '获取详情失败',
    loadAgreementOrderFailed: '加载协议委托号失败',
    loadPermissionTreeFailed: '加载权限树失败',
    loadRolePermissionFailed: '加载角色权限失败',
    assignPermissionFailed: '权限分配失败',
    loadPermissionListFailed: '加载权限列表失败',
    loadOrgListFailed: '加载组织机构列表失败',
    loadOrgStructureTreeFailed: '加载组织结构树失败',
    loadLoginLogFailed: '获取登录日志失败',
    updateConfigFailed: '更新配置失败',
    loadLockedAccountsFailed: '获取锁定账户列表失败',
    unlockAccountFailed: '解锁失败',
    queryAccountFailed: '查询失败',
    // cs-workbench/CsWorkbenchView
    searchBizOrderFailed: '搜索业务委托号失败',
    loadSalesUsersFailed: '加载销售人员失败',
    loadDetailFailed: '加载详情失败',
    saveUpdateFailed: '保存后更新数据失败',
    submitFailed: '提交失败',
    revertFailed: '撤回失败',
    bubbleCancelFailed: '取消分泡失败',
    switchDisplayModeFailed: '切换体现方式失败',
    bubbleApplyFailed: '分泡应用失败',
    copyFailed: '复制失败',
    locateAfterCreateFailed: '新建后定位失败，请手动查找',
    // entry/composables
    hawbCreateFailed: '新增分单失败',
    warehouseCancelFailed: '取消入仓失败',
    matchFailed: '匹配失败',
    returnToPoolFailed: '移回失败',
    loadMawbFailed: '加载主单号失败',
    // entry/dialogs
    dissolveFailed: '撤舱失败',
    lockValidationFailed: '锁定校验失败',
    mawbDuplicate: '主单号编号与已有编号重复，请修改后重试',
    createFailed: '创建失败',
    updateFailed: '更新失败',
    generateBizOrderNoFailed: '生成业务委托号失败',
    // entry/components/CargoModeView
    loadCargoTypeDictFailed: '加载货物类型字典失败',
    // entry/components/PendingWarehouseZone
    setFailed: '设定失败',
    // entry/RouteEntryView
    revokeMawbFailed: '撤销主单号失败',
    locateFailed: '定位失败，请手动查找',
    locateProductOrderFailed: '定位产品委托号失败',
    getBubbleDetailFailed: '获取吃泡分摊详情失败',
    warehouseFailed: '入仓失败',
    unmatchFailed: '解除匹配失败',
    bizOrderNotFound: '未找到业务委托号',
    // composables/api
    loadListFailed: '加载列表失败',
    loadTabCountsFailed: '加载页签计数失败',
    initSseFailed: '初始化实时通知失败',
    disconnectSseFailed: '断开实时通知失败',
    // V6-P0-4: 跨 Tab 编辑占用提示
    entityEditingInOtherTab: '{label} 正在另一个浏览器窗口中编辑，请先关闭那边的编辑或刷新后再试',
    entityEditingInOtherTabNoLabel: '该记录正在另一个浏览器窗口中编辑，请先关闭那边的编辑或刷新后再试',
    // entry/components/CenterPanel/MasterOrderItem
    saveMawbFailed: '保存主单号失败',
    // login/Index.vue
    invalidCredentials: '用户名或密码错误',
    accountLocked: '账户已被锁定，请稍后重试或联系管理员解锁',
    captchaRequired: '请输入验证码',
    captchaFailed: '验证码错误，请重新输入',
    redirectFailed: '登录后跳转失败，请稍后重试',
    passwordChangeFailed: '密码修改失败',
  },
  success: {
    pieceSmartParsed: '已识别并新增 {count} 行',
    operation: '操作成功',
    save: '保存成功',
    delete: '删除成功',
    update: '更新成功',
    created: '创建成功',
    logout: '已退出登录',
    loginSuccess: '登录成功',
    passwordChangedEntering: '密码修改成功，正在进入系统',
    passwordChanged: '密码修改成功，请重新登录',
    passwordChangeFailed: '密码修改失败',
    languageChanged: '语言已切换',
    bizOrderCompleted: '业务委托号已标记完成',
    bizOrderUncompleted: '已撤销完成，回退为已锁定状态',
    lockSuccess: '锁定成功',
    unlockSuccess: '解锁成功',
    atdFilled: 'ATD填写成功',
    ataFilled: 'ATA填写成功',
    customerDeactivated: '已设为无效',
    customerActivated: '已激活',
    userUpdated: '用户更新成功',
    userCreated: '用户创建成功',
    passwordReset: '密码已重置为默认密码',
    userDeleted: '用户已删除',
    userDisabled: '用户已禁用',
    userEnabled: '用户已启用',
    forceChangePasswordEnabled: '已开启强制修改密码',
    forceChangePasswordDisabled: '已关闭强制修改密码',
    dictionaryUpdated: '字典更新成功',
    dictionaryCreated: '字典创建成功',
    dictionaryDeleted: '字典已删除',
    itemUpdated: '选项更新成功',
    itemCreated: '选项创建成功',
    itemDeleted: '选项已删除',
    agreementOrderDisabled: '已失效',
    agreementOrderEnabled: '已生效',
    permissionAssigned: '权限分配成功',
    configUpdated: '配置已更新',
    warehouseDataSaved: '入仓数据已保存',
    cargoChangeSaved: '货运货物变更已保存，已通知相关航线人员',
    // cs-workbench/CsWorkbenchView
    submitSuccess: '提交成功',
    revertSuccess: '撤回成功',
    bubbleCancelSuccess: '取消分泡成功',
    bubbleApplySuccess: '分泡应用成功',
    copyFromHistorySuccess: '从历史单复制成功',
    refreshedToLatest: '已刷新为最新数据',
    switchedToWeightMode: '已切换为按计费重体现',
    switchedToRateMode: '已切换为按单价体现',
    // entry/composables
    hawbCreated: '新增分单成功',
    warehouseCancelSuccess: '取消入仓成功',
    bizOrderMatched: '{no} 已匹配',
    bizOrderReturnedToPool: '{no} 已移回待订舱池',
    // entry/dialogs
    productOrderDissolved: '产品委托号已撤舱',
    productOrderLocked: '产品委托号已锁定',
    diffHandlingSubmitted: '差异处理已提交',
    mawbUpdated: '主单号更新成功',
    mawbCreated: '主单号创建成功',
    productOrderCreated: '产品委托号创建成功',
    // entry/components/PendingWarehouseZone
    salesBaseRateSet: '销售底价设定成功',
    // entry/RouteEntryView
    warehouseSuccess: '入仓成功',
    cancelWarehouseSuccess: '取消入仓成功',
    unmatchSuccess: '解除匹配成功',
    matchSuccess: '匹配成功',
    batchMatchSuccess: '批量匹配完成：成功 {count} 票',
    batchMatchPartialSuccess: '批量匹配完成：成功 {success} 票，失败 {fail} 票',
    deviationAccepted: '已接受入仓数据',
    deviationRejected: '{no} 已解除匹配，退回待订舱池',
  },
  warning: {
    exportOrdersSelectFirst: '请先勾选要导出的业务委托号',
    exportOrdersOnlyWarehoused: '仅可导出已入仓订单，可选择入仓状态筛选',
    warehouseOversoldNonBlocking: '板位已超过超卖容忍阈值，本次入仓仍可继续，请确认业务风险',
    warehouseOversoldDetail: '入仓后毛重总占用 {projected}KG / 毛重总容量 {quota}KG，超过含 {percent}% 容忍的上限 {threshold}KG',
    pieceSmartEmpty: '请先粘贴需要识别的单件信息',
    pieceDimensionIncomplete: '请完整填写每行的长、宽、高、件数',
    dataModified: '数据已被他人修改，请刷新页面后重试',
    loadConfigFailed: '获取配置失败',
    selectSubOrderFirst: '请先勾选要生成的子协议委托号',
    selectCycleDayFirst: '请选择周期日（每周几 / 每月几日）',
    agreementOrderNotSaved: '协议委托号尚未保存，无法批量生成',
    subOrderAutoSaveFailed: '子协议委托号自动保存失败，请手动保存后重试批量生成',
    noChangeDetected: '未检测到任何变更',
    loadViewRecordsFailed: '加载查看记录失败',
    loadSurchargeDictFailed: '加载附加费类型字典失败',
    loadSalesUsersFailed: '加载销售人员失败',
    operationFailed: '操作失败',
    suggestionFailed: '搜索建议失败',
    bubbleLowProfit: '⚠️ 分泡后利润率极低，谨慎操作',
    // entry/composables
    loadPendingBizOrdersFailed: '加载待订舱业务委托号失败',
    switchTabSelectFailed: '切换并选中产品委托号失败',
    // entry/dialogs/AddMasterAirWaybillDialog
    selectIssuingAirline: '请选择签发航司',
    inputMawbNo: '请输入主单号',
    loadMawbDetailFailed: '加载主单号详情失败',
    // entry/dialogs/CreateProductOrderDialog
    getAgreementRemainingFailed: '获取协议剩余重量失败',
    getSubOrderListFailed: '获取子协议列表失败',
    inputProductOrderNo: '请填写产品委托号编号',
    selectProductType: '请选择产品类型',
    fillFlightAndEtd: '请填写航班号、始发、目的地和ETD',
    inputTrunkRate: '请填写干线单价',
    palletWeightRequired: '板位计费重量必须大于0，否则航线无法分配仓位',
    originDestinationRequired: '请填写起运港和目的港',
    transitPortRequired: '中转类运输方式（中转/空运转陆运/联运）必须填写中转港',
    selectSubOrderForCycle: '该协议为循环周期，请选择子协议编号',
    agreementQuotaFlexibleWarning: '协议剩余额度不足或已经超卖。本次操作仍可继续，请操作员确认偏差是否可接受。',
    uldQuotaFlexibleWarning: '板型 {type} 本次使用 {requested} 件，协议剩余 {remaining} 件，允许继续但将形成板型超卖。',
    uldQuotaSaveWarning: '板型 {type} 本次填写 {requested} 板，协议剩余 {remaining} 板，保存后将形成超卖。',
    agreementWeightSaveWarning: '本次计费重量 {requested} KG，协议剩余 {remaining} KG，保存后将形成超卖。',
    agreementOversellConfirmTitle: '确认协议超卖',
    // entry/dialogs/EditProductOrderDialog
    productOrderIdNotFound: '产品委托号ID不存在',
    // entry/components/PalletInfoSection
    getAgreementRemainingQuotaFailed: '获取协议剩余额度失败',
    exceedAgreementRemaining: '⚠ 超出协议剩余可配',
    // entry/components/MawbLocalCostSection
    loadLocalCostFailed: '加载本地费用失败',
    // cs-workbench/components/CenterPanel/BizOrderForm/ProfitDashboard
    bubbleWillCauseLoss: '🔴 分泡后将导致亏损！',
    // cs-workbench/components/CenterPanel/BizOrderForm/WarehouseDataSection
    modifyFailed: '修改失败',
    // cs-workbench/dialogs/BizOrderCreateDialog
    customerCodeAlreadyUsed: '您填写的客户编号已被使用，请修改或从下拉列表中选择已有客户',
    customerNameAlreadyExists: '该客户名称已存在，请从下拉列表中选择已有客户或修改名称',
  },
  confirm: {
    completeBizOrder: '确认将业务委托号 {no} 标记为完成？',
    uncompleteBizOrder: '确认撤销业务委托号 {no} 的完成状态？将回退为已锁定状态。',
    completeTitle: '完成确认',
    uncompleteTitle: '撤销完成确认',
    confirmComplete: '确认完成',
    confirmUncomplete: '确认撤销',
    unlockTitle: '解锁确认',
    confirmUnlock: '确认解锁',
    unlockPromptMessage: '请输入解锁原因',
    unlockPromptPlaceholder: '请输入解锁原因（必填）',
    fillAtdTitle: '填写ATD（实际起飞时间）',
    fillAtaTitle: '填写ATA（实际到达时间）',
    fillAtdPrompt: '确认填写 {flight} ({route}) 的实际起飞时间？',
    fillAtaPrompt: '确认填写 {flight} ({route}) 的实际到达时间？',
    confirmFill: '确认填写',
    deactivateCustomer: '确定将客户“{name}”设为无效？',
    deactivateTitle: '确认失效',
    deleteCustomer: '确定删除客户“{name}”？已关联业务委托号的客户无法删除。',
    deleteTitle: '确认删除',
    resetPassword: '确定要重置用户“{name}”的密码吗？',
    resetPasswordTitle: '确认重置',
    disableUser: '确定要禁用用户“{name}”吗？',
    enableUser: '确定要启用用户“{name}”吗？',
    disableTitle: '确认禁用',
    enableTitle: '确认启用',
    deleteUser: '确定要删除用户“{name}”吗？此操作不可恢复！',
    deleteUserTitle: '确认删除',
    deleteDictionary: '确定要删除字典“{name}”吗？此操作将同时删除其所有选项！',
    deleteDictionaryTitle: '确认删除',
    deleteItem: '确定要删除选项“{name}”吗？',
    deleteItemTitle: '确认删除',
    deleteAgreement: '确定删除协议 “{name}” 吗？',
    deleteAgreementTitle: '提示',
    deleteAgreementOrder: '确认删除该协议委托号吗？',
    deleteAgreementOrderTitle: '提示',
    disableAgreementOrder: '确认将协议委托号 {name} 设为失效吗？一旦失效，后续新建或编辑产品委托号时将不再能选择本协议委托号；已有绑定不受影响。',
    enableAgreementOrder: '确认将协议 {name} 设为生效吗？',
    disableAgreementOrderTitle: '提示',
    enableAgreementOrderTitle: '提示',
    regenerateSubOrdersConfirm: '板位结构已变更，是否重新均分子协议？手动调整将被覆盖。',
    regenerateSubOrdersTitle: '提示',
    batchGenerateConfirm: '该操作不可撤销，如反悔则需要逐个手动删除生成的产品委托号',
    batchGenerateProductOrdersTitle: '批量生成产品委托号',
    deleteRole: '确定要删除该角色吗？',
    deleteRoleTitle: '提示',
    deletePermission: '确定要删除该权限吗？删除后其子权限也会被删除！',
    deletePermissionTitle: '提示',
    deleteOrg: '确定要删除该组织吗？',
    deleteOrgTitle: '提示',
    unlockAccountConfirm: '确定要解锁账户 "{name}" 吗？',
    unlockAccountTitle: '确认解锁',
    baseRateChangedConfirm: '销售底价已变化，是否仍要应用当前试算结果？',
    priceChangedTitle: '价格变化提醒',
    stillApply: '仍要应用',
    // cs-workbench/CsWorkbenchView
    tipTitle: '提示',
    warningTitle: '警告',
    confirmSubmitBooking: '确认提交订舱?',
    confirmRevertToDraft: '确认撤回至草稿?',
    confirmDeleteBizOrder: '确认删除该业务委托号?',
    bubbleDeviationPrompt: '实际入仓数据的泡与预定时偏差较大，需要重新计算分泡报价。',
    bubbleDeviationReminderTitle: '分泡偏差提醒',
    gotIt: '好的',
    refreshNow: '立即刷新',
    later: '稍后',
    // entry/dialogs
    confirmDissolve: '确认撤舱 {no} ({flight} {origin}→{destination})?',
    // entry/components/PendingWarehouseZone
    noSalesBaseRateAlert: '本业务委托尚未给出销售底价，无法进行入仓建单操作。请先设定销售底价。',
    cannotWarehouseTitle: '无法入仓建单',
    warehouseDataNotBackfilledConfirm: '本业务委托号尚未获得实际货物入仓数据，入仓建单将使用委托数据。是否确认继续？',
    warehouseDataNotBackfilledTitle: '入仓数据未回填',
    // entry/RouteEntryView
    deleteMawbConfirm: '撤销后该主单号将释放回主单号池，可被后续取号使用。是否确认撤销？',
    deleteMawbWithHawbsConfirm: '主单内还有 {count} 票分单，撤销后分单将取消入仓，对应业务委托号将回到待入仓区域。是否确认撤销？',
    deleteHawbConfirm: '确认删除该分单号吗？',
    saveFailedTitle: '保存失败',
  },
  info: {
    unmatchedNoCost: '未匹配，暂无成本信息',
    unlinkedNoTrunkCost: '未关联产品委托号，暂无干线成本信息',
    editCustomerSegment: '编辑客户段',
    noMawbNo: '未填主单号',
    noHawb: '暂无分单',
    noHawbData: '暂无分单数据',
    noMawbClickToAdd: '暂无主单号，请点击"{button}"',
    noMawbData: '暂无主单号数据',
    clickCategoryToViewDetail: '点击分类查看详情',
    pleaseSelectDictionary: '请从左侧选择字典分类',
    currentEditing: '当前编辑：{name} ({code})',
    notSet: '未设置',
    noDescription: '暂无描述信息',
    agreementDetailTitle: '协议详情 - {name}',
    agreementOrderDetailTitle: '协议委托号详情 - {name}',
    noPalletStructure: '暂无板位结构信息',
    subOrderListTitle: '子协议委托号列表（{cycle}划分）',
    cycleWeekly: '按周',
    cycleBiweekly: '每2周',
    cycleSemimonthly: '半月',
    cycleMonthlyWeek: '月度周',
    cycleMonthly: '按月',
    biweeklyDayLabel: '第{week}周 {weekday}',
    forwardCycleDay: '正数第{day}天',
    reverseCycleDay: '倒数第{day}天',
    productOrderOccupyingQuota: '占用协议额度的产品委托号',
    noProductOrderOccupyingQuota: '暂无产品委托号占用该协议额度',
    operationTimeline: '操作时间轴',
    cycleTotalSum: '各周期总重之和：',
    cycleTotalMatch: '✓ 与协议总重一致',
    cycleTotalMismatch: '✗ 与协议总重不符（应等于 {total} KG）',
    selectedSubOrders: '已选 {count} 个子协议',
    batchPreviewTitle: '生成前分配预览（重叠日期会合并产品，但保留多份重量）',
    batchPreviewSummary: '预计生成 {count} 个产品委托号；分配合计 {allocated} KG，应分配 {expected} KG。',
    batchPreviewMatch: '✓ 总量一致',
    batchPreviewMismatch: '✗ 总量不一致，禁止生成',
    noQuotaAllocated: '未分配额度',
    selectCycleAndPalletFirst: '请先选择协议周期并填写板位明细',
    selectCycleAndWeightFirst: '请先选择协议周期并填写计费重量配额',
    volumeCycleAllocationHint: '包量额度按周期均分，采用整数KG并优先以100KG为最小分配单位；可在保存前按实际情况调整。',
    selectedAgreementId: '已选择协议 ID: {id}',
    saveAsNewAgreement: '将作为新协议保存（航司将一并存入新协议）',
    executionMethodLocked: '协议委托号已在进行中，不可更改本设置。',
    executionMethodHint: '填完板位结构（总量）后再选择执行方式；切换为循环周期后将自动均分子协议',
    agreementAirlineHint: '航司已从所选协议带出，可在此调整（仅影响本协议委托号）',
    batchGenerateSuccess: '成功生成 {count} 个产品委托号',
    batchGenerateCreatedOrderNos: '编号: {nos}',
    batchGenerateSkippedNoMatch: '无匹配日期的子协议: {nos}',
    batchGenerateSkippedOccupied: '已被占用的子协议: {nos}',
    noLockedAccounts: '暂无被锁定的账户',
    accountLockHint: '当用户连续登录失败5次后，账户将被锁定30分钟。管理员可以在此处手动解锁被锁定的账户。',
    selectPermissionToView: '请在左侧选择权限查看详情',
    chargeWeightRuleTitle: '计费重计算规则说明',
    chargeWeightRuleHint1: '半公斤向上进位：IATA TACT 标准行规，计费重不满 0.5kg 的部分一律进位到下一个 0.5kg（如 1.01→1.5，2.5→2.5），系统默认。',
    chargeWeightRuleHint2: '四舍五入：计费重保留 2 位小数（系统原有计算方式）。',
    chargeWeightRuleHint3: '本规则为全局基础配置，影响所有计费重及利润计算；切换规则仅影响后续计算，历史数据不回溯调整。',
    serialNumberRuleTitle: '编号生成规则说明',
    serialNumberRuleFormat: '编号格式：前缀-年月日-流水号，如 WTH-20260508-0001',
    serialNumberRuleSequence: '流水号每日从0001开始递增，4位数字，不足补零',
    serialNumberRuleConcurrency: '并发安全：系统使用数据库行级锁保证多用户同时新建时编号不重复',
    serialNumberRuleNote: '注意：编号在点击新建时即分配，即使用户未保存，该编号也不会再次分配',
    bubbleDeviationTitle: '分泡偏差检测说明',
    bubbleDeviationRule1: '当实际入仓数据的可分泡部分重量与预定时差异超过此阈值时，系统会弹窗提醒用户重新计算分泡报价',
    bubbleDeviationRule2: '可分泡部分 = 标准计费重(1:167) - 基准计费重(1:泡比)',
    bubbleDeviationRule3: '差异百分比 =｜实际可分泡部分 - 预定可分泡部分｜/ 预定可分泡部分 × 100%',
    // cs-workbench/BizOrderCargoSection
    toBeCalculated: '待计算',
    actualWeightHint: '已是实重（勾选后将货物信息自动同步为入仓数据）',
    warehouseDataAlreadyEntered: '入仓数据已填写，您可直接到入仓数据区域修改',
    pieceDetailEdit: '单件信息（编辑）',
    pieceSmartEntry: '智能录入',
    pieceSmartFormat: '每行代表一种货物，固定顺序为：长、宽、高、件数（尺寸单位：厘米）。支持空格、逗号、×、x、X、*、/ 等分隔符。',
    pieceSmartExamples: '示例：120 80 60 10　或　100×60×40×5',
    pieceDetailView: '单件信息（查看）',
    // cs-workbench/WarehouseBackfillDrawer
    warehouseBackfillTitle: '录入实际入仓数据',
    bookedVsActual: '委托数据 vs 实际入仓',
    bookedEstimate: '委托预估',
    actualWarehouseData: '实际入仓数据',
    bubbleAmount: '吃泡',
    // cs-workbench/BizOrderList
    loadingInProgress: '正在加载中...',
    noDataInCurrentTab: '当前Tab暂无数据',
    otherTabsHaveRecords: '其他Tab有 {count} 条记录',
    noBizOrders: '暂无业务委托号',
    routeUnviewedGroup: '⏳ 航线未查看（{count}票）',
    routeViewedGroup: '👁️ 航线已查看（{count}票）',
    pendingBackfillGroup: '🔶 待补录入仓数据（{count}票）',
    confirmedActualGroup: '✅ 已确认实际数据（{count}票）',
    searchEmptyInTab: '本页签下无搜索结果，请查看其他页签',
    searchBizOrderTip: '支持模糊搜索：业务委托号 / 客户名称 / 主单号（如 999-12345678）/ 分单号',
    noDataForTab: '暂无{tab}的业务委托号',
    allLoaded: '已加载全部 {count} 条',
    bubbleDeviationWarning: '实际入仓数据的泡与预定时偏差较大',
    // cs-workbench/BizOrderForm
    routeViewRecords: '航线查看记录',
    noRecords: '暂无记录',
    rdlNotFilled: 'RDL未填',
    pendingUnviewedHint: '当前处于待订舱（航线未查看），可全量修改所有信息',
    pendingViewedHint: '航线已查看，可修改客户信息和收入信息；如需修改货运/货物信息，请点击"货运货物变更"按钮',
    cargoChangeEditingHint: '货运货物变更编辑中，保存后将通知所有查看过本业务委托号的航线人员',
    cargoChangeEditingHintTracking: '货运货物变更编辑中，保存后将向航线人员发出强通知',
    toBeMatched: '待匹配',
    pendingBaseRate: '待设定底价',
    // cs-workbench/BizOrderCreateDialog
    bizOrderNoHint: '手工录入或留空自动生成',
    customerCodeHint: '系统带出或手工录入',
    suggestedUldTypeHint: '提交后自动推导',
    // cs-workbench/BubbleCalcDialog
    bubbleCalcTitle: '💰 分泡报价试算',
    basicData: '【基础数据】',
    dataSourceActual: '数据来源：实际入仓',
    bubbleConfigSection: '【分泡配置】',
    calcResultSection: '【试算结果】',
    bubbleRatioTitle: '泡比',
    bubbleShareRatioTitle: '分泡比例',
    notParticipateBubble: '(不参与分泡)',
    salesGrossProfitImpact: '销售毛利影响:',
    receivableImpact: '应收合计影响:',
    bubbleMeaningless: '基准计费重 ≥ 标准计费重，分泡无意义',
    bubbleNegativeProfit: '🔴 分泡后销售毛利为负！',
    baseRateChangedTitle: '销售底价已变化',
    baseRateChangedDesc: '航线已更新销售底价，当前试算结果可能不准确，建议关闭后重新打开',
    recalculate: '重新计算',
    // cs-workbench/CsWorkbenchView
    selectBizOrderHint: '请从左侧选择一个业务委托号',
    selectBizOrderHintDesc: '选择后可查看详情、编辑信息、管理应收应付',
    dataModifiedByOther: '数据已被他人修改，已为您加载最新数据',
    confirmFeeWIP: '确认费用功能开发中',
    notifyCustomerWIP: '通知客户功能开发中',
    baseRateUpdatedReminder: '航线已更新销售底价，当前显示的毛利数据可能不准确，请刷新查看最新数据',
    baseRateUpdatedDetail: '航线已更新销售底价：\n{oldRate}/KG → {newRate}/KG\n当前显示的毛利数据可能不准确，请刷新查看最新数据',
    baseRateSetReminder: '航线已设定销售底价：{rate}/KG\n当前显示的毛利数据可能不准确，请刷新查看最新数据',
    // entry/dialogs
    dissolveTitle: '撤舱产品委托号',
    dissolveEffectsTitle: '撤舱后：',
    dissolveEffect1: '旗下{count}票业务委托号将回退到"待订舱（航线已查看）"状态',
    dissolveEffect2: '业务委托号与产品委托号的关联将解除',
    dissolveEffect3: '已制单的分单号将被删除',
    dissolveEffect4: '此操作不可撤销',
    lockProductOrderTitle: '锁定产品委托号',
    lockEffectsTitle: '锁定后将：',
    lockEffect1: '旗下业务委托号同步锁定',
    lockEffect2: '所有数据不可再修改',
    warehouseDataFilled: '实际入仓数据已回填',
    warehouseDataNotFilled: '实际入仓数据未回填',
    salesProfitPositive: '销售毛利为正',
    salesProfitNegative: '销售毛利为负',
    bizOrderSalesProfitNegative: '业务委托号{no} 销售毛利为负',
    mawbReservedNone: '主单号无预占未使用',
    mawbReservedUnused: '存在预占未使用的主单号',
    airlineWeightDiffTitle: '航司称重差异处理',
    warehouseDataSection: '入仓数据（制单时录入）',
    airlineDataSection: '航司数据（机场货站回填）',
    diffAnalysisSection: '差异分析',
    handlingMethodSection: '处理方式',
    amendDesc: '修改分单重量为航司数据，向客户补收/退还差价',
    absorbDesc: '差异在5%以内，货代自行承担，航线毛利微调',
    disputeDesc: '认为航司称重有误，申请复称或退仓',
    bizOrderDetailTitle: '业务委托号详情',
    bizOrderDetailTitleWithNo: '业务委托号详情 - {no}',
    basicInfoTab: '基础信息',
    bookedInfo: '委托信息',
    specialAttributes: '特殊属性',
    pieceDetailTitle: '单件明细',
    hawbDetailTitle: '分单号详情',
    hawbDetailTitleWithNo: '分单号详情 - {no}',
    partiesTab: '收发货人',
    bubbleAllocationTab: '吃泡分摊',
    loadItemsTab: '装载明细',
    shipper: '发货人',
    consignee: '收货人',
    notifyParty: '通知方',
    inheritedFromProductOrder: '继承自产品委托号',
    // entry/dialogs/CreateProductOrderDialog
    agreementOrderOptionalSection: '协议委托号（可选）',
    uldTypeAndChargeWeight: '板型与计费重量',
    selectSubOrderFirstHint: '请先选择子协议编号，将带出对应周期的板位结构',
    allAgreementUldTypesListed: '这些是本协议委托号内所有的板型和板重了',
    allUldTypesListed: '所有板位类型均已列出',
    agreementPeriodLabel: '协议周期: {start} 至 {end}',
    agreementUnitPriceLabel: '单价: {price} {currency}/KG',
    agreementTotalWeightLabel: '协议板位计费合计: {weight} KG',
    agreementRemainingLabel: '剩余可配: {weight} KG',
    agreementOccupiedByOthers: '(已分配 {weight} KG)',
    noRemainingAgreementUld: '当前周期没有剩余协议板位；仍可新增板型，保存时系统会提示是否形成超卖。',
    noAirlinePalletConfig: '当前航司尚未配置可用板型，请先在板型管理中维护。',
    uldPoolTotalFormat: '{weight} KG（{count} 板）',
    costPricing: '成本定价',
    uldCountLabel: '板数:',
    chargeWeightLabel: '计费重量:',
    addUldType: '+ 添加板型',
    subOrderOptionLabel: '{no} ({start} ~ {end}) 剩余 {weight} KG{occupied}',
    subOrderOccupied: ' [已占用]',
    // entry/dialogs/EditProductOrderDialog
    volumeTag: '包量',
    bsaTag: '包板',
    volumeTagBracket: '[包量]',
    bsaTagBracket: '[包板]',
    remainingAllocatableLabel: '剩余可配:',
    uldUnit: '板',
    // entry/components/PanelHeader
    oversold: '超卖',
    infoOverview: '信息纵览',
    alertEtdUrgentWarehouse: '临期未入仓',
    alertEtdUrgentBooking: '临期未制单',
    alertEtdOverdue: 'ETD逾期',
    alertDefault: '告警',
    // entry/components/Index, BaseInfoSection, PalletInfoSection
    routeWorkbench: '航线工作台',
    suggestedPalletAndChargeWeight: '建议板型与计费重量',
    independentPallet: '独立板位',
    linkedLabel: '已关联:',
    linkedAgreementLabel: '已关联协议:',
    totalLabel: '合计:',
    // entry/components/ChangeRequestDrawer
    changeConfirmTitle: '变更确认',
    rejectChangeTitle: '驳回变更',
    noPendingChangeRequests: '暂无待处理的变更申请',
    bizOrderNoWithId: '业务委托号#{id}',
    // entry/components/CargoModeView
    smartPackSuggestions: '智能打包建议',
    ticketCount: '{count}票',
    pieceCountFormat: '{count}件',
    matchToThisSpace: '匹配到此舱',
    noPendingBookingBizOrders: '暂无待订舱业务委托号',
    // entry/components/MawbLocalCostSection
    payableDetailRouteCost: '应付明细（航线成本）',
    // entry/components/MasterOrderItem/HawbDetailDialog
    bizOrderInfo: '业务委托信息',
    hawbInfo: '分单信息',
    bubbleCalcResult: '吃泡计算结果',
    // entry/components/RightPanel
    dragBackToUnmatch: '拖回此处取消匹配',
    findCargoBySpace: '按舱找货',
    findSpaceByCargo: '按货看舱',
    selectedTicketsCount: '已选 {count} 票',
    // entry/components/WarehouseConfirmDrawer
    warehouseCreateTitle: '入仓建单',
    bookedCargoData: '委托货物数据',
    actualWarehouseDataSection: '实际入仓数据',
    hawbInfoSection: '分单号信息',
    relatedMawbTitle: '关联主单号',
    unfilledMawbNo: '未填主单号 ({origin}→{destination})',
    unfilledMawbNoShort: '未填主单号',
    loadItemsWithPallet: '装载明细（板位分配）',
    costEstimate: '成本预估',
    entered: '已录入',
    pendingEntry: '待录入',
    warehouseDataNotEnteredTip: '客服尚未录入实际入仓数据，入仓建单将使用委托数据作为预估',
    addLoadRow: '+ 添加装载行',
    chargeWeightTotalLabel: '计费重合计:',
    independentCostFormula: '独立成本(计费重×销售底价)',
    trunkCostFormula: '干线成本(计费重×干线单价)',
    // entry/components/PendingWarehouseZone
    pendingWarehouseCount: '待入仓 ({count})',
    notBackfilled: '未回填',
    actualPrefix: '✅ 实际:',
    warehouseDataNotBackfilledTip: '⚠️ 入仓数据未回填，制单将使用委托数据',
    pendingSet: '待设定',
    dragBizOrderHere: '拖拽业务委托号到此处',
    // entry/RouteEntryView
    selectProductOrderHint: '请从左侧选择一个产品委托号',
    selectProductOrderHintDesc: '选择后可查看详情、管理主单号和分单号',
    bubbleAllocationDetailTitle: '吃泡分摊算法详情 - {desc}',
    bubbleStep1: '第1步：各分单独立计算',
    bubbleStep2: '第2步：合并计费重与实际总成本',
    bubbleStep3: '第3步：总节省',
    bubbleStep4: '第4步：体积偏差',
    bubbleStep5_6: '第5-6步：节省分配与最终分摊',
    bubbleTotalWeightSigma: '总实重 ΣW',
    bubbleTotalVolumeSigma: '总体积 ΣV',
    bubbleTotalBubbleWeight: '总泡重',
    bubbleTotalChargeWeight: '合计费重',
    bubbleIndependentCostTotal: '独立成本合计',
    bubbleActualTotalCost: '实际总成本',
    bubbleTotalSavingFormula: '总节省 = 独立成本合计 - 实际总成本',
    bubbleDeviationPool: '偏差池 = Σ｜偏差｜',
    bubbleCalcScenario: '计算场景',
    bubbleTrunkRateP: '干线单价(P)',
    bubbleVolumeRatio: '体积换算系数',
    bubbleColWeight: '实重W(kg)',
    bubbleColVolume: '体积V(CBM)',
    bubbleColVolWeight: '泡重(kg)',
    bubbleColChargeWeight: '计费重(kg)',
    bubbleColIndepCost: '独立成本(元)',
    bubbleColActualVolume: '实际体积V',
    bubbleColAbsDeviation: '｜偏差｜',
    bubbleColEffRateGross: '折合单价（毛重）',
    bubbleColBubbleRate: '吃泡单价（计费重）',
    bubbleAllowedVolumeFormula: '允许体积(W×{ratio})',
    warehouseDataChangeReminder: '入仓数据变更提醒',
    deviationTip: '业务委托号 {no} 的实际入仓数据与委托时有变化',
    bookedPrefix: '委托：',
    actualPrefixLabel: '实际：',
    deviationDataFormat: '重量 {w}KG，体积 {v}CBM，计费重 {cw}KG',
    selectHandlingMethod: '请选择处理方式：',
    deviationAcceptDesc: '接受当前入仓数据，继续匹配',
    deviationAdjustDesc: '接受数据但需重新评估底价',
    deviationRejectDesc: '解除匹配，业务委托号退回待订舱池',
    // entry/RouteEntryView 货运货物变更强提醒弹窗
    cargoChangeReminder: '货运货物变更提醒',
    cargoChangeTip: '业务委托号 {no} 的货物信息已被客服修改，请关注',
    cargoChangeFieldCol: '变更项',
    cargoChangeOldCol: '原值',
    cargoChangeNewCol: '新值',
    cargoChangeAckDesc: '确认后刷新产品委托号详情，展示最新货物数据',
    opsBackfillWIP: '运营数据回填功能开发中',
    editHawbWIP: '编辑分单号功能开发中',
    sortWIP: '排序功能开发中',
    approveChangeWIP: '批准变更功能开发中',
    rejectChangeWIP: '拒绝变更功能开发中',
    modifySalesBaseRateHint: '请在该卡片的销售底价处进行修改',
    // entry/components/RightPanel/MatchModeView
    anchorCurrentProductOrder: '锚定当前产品委托',
    // cs-workbench/components/CenterPanel/BizOrderForm/ProfitDashboard
    afterBubble: '分泡后',
    // entry/components/LeftPanel/ProductOrderList
    noProductOrderForTab: '暂无{tab}的产品委托号',
    // entry/components/LeftPanel/ProductOrderCard 徽章
    badgeChange: '变',
    badgeAdjust: '调',
    badgeDiff: '差',
    badgeEstimate: '估',
    badgeWarehouse: '回',
    badgeRate: '底',
    badgeBubble: '泡',
    // entry/components/LeftPanel/ProductOrderCard 告警
    oversoldPercent: '超卖 {percent}%',
    etdExpired: 'ETD已过期',
    // cs-workbench/components/RightPanel/SmartAssistPanel
    noBizOrderSelected: '未选择业务委托号',
    noRouteRecommendations: '暂无航线推荐',
    matchScorePercent: '{score}%匹配',
    // entry/components/CenterPanel/MasterOrderItem/HawbCard
    savingFormat: '(节省¥{amount})',
    airlineWeightDiffPending: '⚠️ 航司称重差异待处理',
    diffResolved: '✅ 差异已处理({handling})',
    // cs-workbench/components/CenterPanel/BizOrderForm/WarehouseDataSection
    warehouseDataModified: '入仓数据已修改',
  },
  // businessOrders/Detail.vue 错误
  loadBizOrderDetailFailed: '加载业务委托详情失败',
  loadProfitDataFailed: '获取分润数据失败',
  firstTierProfitNegative: '一级包分润为负，请核查客户卖价',
  lockFailed: '锁定失败',
  unlockFailed: '解锁失败',
  validate: {
    passwordMismatch: '两次输入的密码不一致',
    passwordRequired: '请输入当前密码',
    newPasswordRequired: '请输入新密码',
    confirmPasswordRequired: '请再次输入新密码',
    passwordTooShort: '密码长度不能少于6位',
    usernameExists: '用户名已存在',
    userNotFound: '用户不存在',
    usernameRequired: '请输入用户名',
    passwordRequiredLogin: '请输入密码',
    passwordMinLength: '密码长度至少6位',
    captchaRequired: '请输入验证码',
    selectAtdTime: '请选择ATD时间',
    selectAtaTime: '请选择ATA时间',
    customerNameRequired: '请输入客户名称',
    realNameRequired: '请输入姓名',
    roleRequired: '请选择角色',
    userOrgRequired: '请选择本用户所属部门',
    dictCodeRequired: '请输入字典编码',
    dictNameRequired: '请输入字典名称',
    itemCodeRequired: '请输入选项编码',
    itemNameRequired: '请输入选项名称',
    agreementNoRequired: '请输入协议编号',
    agreementNoMaxLength: '协议编号长度不能超过100',
    agreementEntrustNoRequired: '请输入协议委托编号',
    selectAirlineRequired: '请选择航司',
    originRequired: '请输入始发港',
    originPattern: '3位大写',
    destinationRequired: '请输入目的港',
    destinationPattern: '3位大写',
    agreementPeriodRequired: '请选择协议周期',
    agreementUnitPriceRequired: '请输入协议单价',
    currencyRequired: '请选择币种',
    cycleModeRequiresSubOrders: '循环周期下必须生成子协议列表',
    cycleTotalWeightMismatch: '各周期总重之和（{sub} KG）必须等于协议总重（{total} KG）',
    uldTypeCountMismatch: '板型 {type} 的各周期板数之和（{sum}）必须等于总数（{total}）',
    roleCodeRequired: '请输入角色编码',
    roleNameRequired: '请输入角色名称',
    permissionCodeRequired: '请输入权限编码',
    permissionNameRequired: '请输入权限名称',
    permissionTypeRequired: '请选择权限类型',
    orgCodeRequired: '请输入组织编码',
    orgNameRequired: '请输入组织名称',
    configValueRequired: '值不能为空',
    actualWeightRequired: '请输入实际重量',
    actualVolumeRequired: '请输入实际体积',
    // cs-workbench/BizOrderForm
    customerNameCannotBeEmpty: '客户名称不能为空',
    customerCodeCannotBeEmpty: '客户代码不能为空',
    // cs-workbench/BizOrderCreateDialog
    customerCodeRequired: '请输入客户代码',
    regionSelectRequired: '请选择区域',
    customerSourceRequired: '请选择客户来源',
    legalEntityRelationRequired: '请选择法人关系',
    salesOwnerRequired: '请选择销售归属',
    contactNameRequired: '请输入联系人',
    contactPhoneRequired: '请输入联系电话',
    departureRequired: '请输入起运港',
    destinationPortRequired: '请输入目的港',
    transportModeRequired: '请选择运输方式',
    hawbPrealertDeclaredRequired: '请选择是否申报分单预配',
    taxFlagRequired: '请选择应税/免税',
    shippingTermsRequired: '请输入运输条款',
    serviceItemsRequired: '请选择服务项',
    orderCategoryRequired: '请选择订单类别',
    piecesRequired: '请输入件数',
    weightRequired: '请输入重量',
    volumeRequired: '请输入体积',
    cargoTypeRequired: '请选择货物类型',
    sellCurrencyRequired: '请选择卖价币种',
    sellRateRequired: '请输入卖价单价',
    // entry/dialogs
    dissolveReasonRequired: '请选择撤舱原因',
    // entry/components/ChangeRequestDrawer
    rejectReasonRequired: '请输入驳回原因',
    // entry/components/WarehouseConfirmDrawer
    selectMawbNo: '请选择主单号',
    selectUldType: '请选择板型',
    // entry/components/PendingWarehouseZone
    invalidSalesBaseRate: '请输入有效的销售底价',
  },
  // businessOrders/Index.vue 错误
  loadDataFailed: '加载数据失败',
  loadProductOrderFailed: '加载产品委托号失败',
  // productOrderRecord/Index.vue 错误
  atdFillFailed: 'ATD填写失败',
  ataFillFailed: 'ATA填写失败',
}
